import React, { useEffect, useState } from "react";
import "./EditSession.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import {
  createSessionService,
  editSessionService,
  deleteSessionService,
  getSessionService,
  getStudentsBySessionService,
  getHolidaysByMonth,
  get_students_by_section,
  getAllHostels,
  getStudentsByHostel,
} from "../../services/api-service";

import { useHistory } from "react-router-dom";
import styles from "../emotions-summary/index.module.css";

const Spinner = ({ size = 18, color = "#fff" }) => (
  <svg width={size} height={size} viewBox="0 0 50 50" aria-hidden>
    <circle
      cx="25"
      cy="25"
      r="20"
      stroke={color}
      strokeWidth="5"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="31.4 31.4"
    >
      <animateTransform
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="1s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
);

export default function EditSessionDetails() {
  const [sessionData, setSessionData] = useState([]);
  const [sessionIds, setSessionIds] = useState([]);
  const [values, setValues] = useState({
    session_id: "",
    course_name: "",
    location: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
  });
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [studentsId, setStudentsId] = useState([]);

  const [sections, setSections] = useState([]);
  const [selectedAdditionalSections, setSelectedAdditionalSections] = useState([]);

  const [calendarDates, setCalendarDates] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [holidays, setHolidays] = useState({});
  const [loadingCalendar, setLoadingCalendar] = useState(false);

  const [sessionMode, setSessionMode] = useState(null);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
  const [hostels, setHostels] = useState([]);
  const [selectedHostel, setSelectedHostel] = useState(null);
  const [loadingHostels, setLoadingHostels] = useState(false);
  const [filterByHostel, setFilterByHostel] = useState(false);
  
  const history = useHistory();
  const base64 = "data:image/png;base64";

  useEffect(() => {
    fetchSessions();
    fetchAllSections();
  }, []);

  // ✅ Fetch all available sections
  const fetchAllSections = async () => {
    try {
      const response = await get_students_by_section();
      console.log("📍 Full API Response:", response);
      
      let studentsList = [];
      
      if (Array.isArray(response?.students)) {
        studentsList = response.students;
      } else if (Array.isArray(response?.data?.students)) {
        studentsList = response.data.students;
      } else if (Array.isArray(response?.data)) {
        studentsList = response.data;
      } else if (Array.isArray(response)) {
        studentsList = response;
      }

      console.log("👥 Students List:", studentsList);

      const uniqueSections = [...new Set(studentsList.map(s => s.section))];
      console.log("🏢 Unique Sections:", uniqueSections);

      const sectionOptions = uniqueSections
        .filter((sec) => sec && sec !== "undefined" && sec !== "null")
        .map((sec) => ({
          label: sec,
          value: sec,
        }));

      console.log("📋 Section Options:", sectionOptions);
      setSections(sectionOptions);
    } catch (err) {
      console.error("❌ Error fetching sections:", err);
      toast.error("Failed to load sections");
    }
  };

  const fetchSessions = async () => {
    try {
      const res = await getSessionService();
      setSessionData(res.data || []);
      const options = (res.data || []).map((el) => ({
        label: `${el.session_id} - ${el.course_name}`,
        value: String(el.session_id),
      }));
      setSessionIds(options);
    } catch (err) {
      toast.error("Failed to load sessions");
      console.error(err);
    }
  };

  // ✅ Fetch all hostels
  const fetchAllHostels = async () => {
    setLoadingHostels(true);
    try {
      const res = await getAllHostels();
      console.log("✅ Hostels response:", res);
      
      let hostelList = [];
      if (res?.data?.data && Array.isArray(res.data.data)) {
        hostelList = res.data.data;
      } else if (res?.data && Array.isArray(res.data)) {
        hostelList = res.data;
      }
      
      console.log("✅ Hostel list:", hostelList);
      
      const hostelOptions = hostelList.map((hostel) => ({
        label: hostel,
        value: hostel,
      }));

      setHostels(hostelOptions);
      setSelectedHostel(null);
      setFilterByHostel(true);

      if (hostelOptions.length > 0) {
        console.log(`✅ Found ${hostelOptions.length} hostels in system`);
      } else {
        setFilterByHostel(false);
      }
    } catch (err) {
      console.error("Error fetching hostels:", err);
      setHostels([]);
      setFilterByHostel(false);
    } finally {
      setLoadingHostels(false);
    }
  };

  // ✅ Handle hostel selection
  const handleHostelChange = async (selected) => {
    setSelectedHostel(selected);
    setStudentsId([]);

    if (!selected) {
      // Cleared hostel - reset to primary location students
      if (values.location) {
        setLoadingStudents(true);
        try {
          const response = await get_students_by_section(values.location);
          let studentsList = [];
          if (Array.isArray(response?.data?.students)) {
            studentsList = response.data.students;
          } else if (Array.isArray(response?.data)) {
            studentsList = response.data;
          }
          setStudents(studentsList);
          setStudentsId(studentsList.map((s) => s.student_id));
          
          // Reset calendar to regular schedule: Mon-Sat (no holidays)
          if (calendarDates.length > 0) {
            const regularWeekdays = calendarDates
              .filter(d => !d.isSunday && !d.isHoliday)
              .map(d => d.date);
            setSelectedDates(regularWeekdays);
            console.log(`📅 Regular class schedule: ${regularWeekdays.length} days (Mon-Sat, no holidays)`);
          }
          
          toast.info(`ℹ️ Cleared hostel filter - regular class schedule (Mon-Sat)`);
        } catch (err) {
          console.error("Error fetching students:", err);
          toast.error("Failed to load students");
        } finally {
          setLoadingStudents(false);
        }
      }
      return;
    }

    setLoadingStudents(true);
    try {
      // Get students from hostel
      const res = await getStudentsByHostel(selected.value);
      let studentsList = [];
      if (res?.data?.students && Array.isArray(res.data.students)) {
        studentsList = res.data.students;
      } else if (res?.data && Array.isArray(res.data)) {
        studentsList = res.data;
      }

      setStudents(studentsList);
      setStudentsId(studentsList.map((s) => s.student_id));
      
      // AUTO-SET HOSTEL SCHEDULE: EVERY DAY (including Sundays and holidays)
      if (calendarDates.length > 0) {
        const hostelDates = calendarDates.map(d => d.date);
        setSelectedDates(hostelDates);
        
        console.log(`🏨 Hostel attendance schedule: ${hostelDates.length} days (EVERY DAY)`);
      }
      
      toast.success(
        `✅ Loaded ${studentsList.length} students from ${selected.label}\n` +
        `📅 Schedule set to EVERY DAY (including weekends & holidays)`
      );
    } catch (err) {
      console.error("Error fetching hostel students:", err);
      toast.error("Failed to load hostel students");
      setStudents([]);
    } finally {
      setLoadingStudents(false);
    }
  };

  // ✅ Handle session selection
  const handleSelectSession = async (option) => {
    if (!option) {
      resetSessionView();
      return;
    }

    try {
      setLoadingStudents(true);
      const sessionRecord = sessionData.find(
        (s) => String(s.session_id) === String(option.value)
      );

      if (!sessionRecord) {
        toast.error("Session not found");
        return;
      }

      console.log("📋 Selected session record:", sessionRecord);

      setValues({
        session_id: String(sessionRecord.session_id),
        course_name: sessionRecord.course_name,
        location: sessionRecord.location,
        start_date: sessionRecord.start_date,
        end_date: sessionRecord.end_date,
        start_time: sessionRecord.start_time,
        end_time: sessionRecord.end_time,
      });

      // Fetch students
      const studentsRes = await getStudentsBySessionService({
        session_id: String(sessionRecord.session_id),
      });
      
      const studentsList = studentsRes?.data || [];
      setStudents(studentsList);
      setStudentsId(studentsList.map((s) => s.student_id));

      // Handle additional_sections
      let storedAdditionalSections = sessionRecord.additional_sections || [];
      console.log("📍 Additional sections from API (raw):", storedAdditionalSections);
      console.log("📍 Type:", typeof storedAdditionalSections);

      if (typeof storedAdditionalSections === 'string') {
        try {
          storedAdditionalSections = JSON.parse(storedAdditionalSections);
          console.log("✅ Parsed JSON string:", storedAdditionalSections);
        } catch (e) {
          console.error("❌ Failed to parse JSON:", e);
          storedAdditionalSections = [];
        }
      }

      if (!Array.isArray(storedAdditionalSections)) {
        console.warn("⚠️ Not an array, resetting to empty array");
        storedAdditionalSections = [];
      }

      console.log("📍 Final additional sections:", storedAdditionalSections);
      console.log("📊 Count:", storedAdditionalSections.length);

      if (storedAdditionalSections.length > 0 && sections.length > 0) {
        console.log("🔍 Available sections:");
        sections.forEach(sec => console.log(`  - ${sec.value}`));
        
        console.log("🔍 Trying to match:");
        storedAdditionalSections.forEach(sec => console.log(`  - ${sec}`));
        
        const preSelectedAdditional = sections.filter(sec => 
          storedAdditionalSections.includes(sec.value)
        );
        
        console.log("✅ Pre-selected sections:", preSelectedAdditional);
        console.log(`📊 Found ${preSelectedAdditional.length} matches`);
        setSelectedAdditionalSections(preSelectedAdditional);
      } else {
        console.log("📋 No additional sections to pre-select");
        setSelectedAdditionalSections([]);
      }

      // Load class dates
      const savedClassDates = sessionRecord.class_dates || [];
      setSelectedDates(savedClassDates);

      setSelectedSessionId(String(sessionRecord.session_id));
      setSessionMode("view");
      setCalendarDates([]);
      await fetchAllHostels();
      toast.success(`✅ Loaded session: ${sessionRecord.session_id}`);
    } catch (err) {
      console.error("❌ Error loading session:", err);
      toast.error("Failed to load session details");
    } finally {
      setLoadingStudents(false);
    }
  };

  const resetSessionView = () => {
    setSessionMode(null);
    setSelectedSessionId(null);
    setValues({
      session_id: "",
      course_name: "",
      location: "",
      start_date: "",
      end_date: "",
      start_time: "",
      end_time: "",
    });
    setStudents([]);
    setStudentsId([]);
    setCalendarDates([]);
    setSelectedDates([]);
    setHolidays({});
    setSelectedAdditionalSections([]);
    setHostels([]);
    setSelectedHostel(null);
    setFilterByHostel(false);
  };

  // ✅ Handle additional sections change
  const handleAdditionalSectionsChange = async (selectedOptions) => {
    setSelectedAdditionalSections(selectedOptions || []);

    setLoadingStudents(true);
    try {
      const primaryLocation = values.location;
      console.log(`📍 Loading students from primary location: ${primaryLocation}`);
      
      const primaryResponse = await get_students_by_section(primaryLocation);
      
      let allStudents = [];
      
      if (Array.isArray(primaryResponse?.students)) {
        allStudents = primaryResponse.students;
      } else if (Array.isArray(primaryResponse?.data?.students)) {
        allStudents = primaryResponse.data.students;
      } else if (Array.isArray(primaryResponse?.data)) {
        allStudents = primaryResponse.data;
      } else if (Array.isArray(primaryResponse)) {
        allStudents = primaryResponse;
      }
      
      console.log(`✅ Loaded ${allStudents.length} students from primary location ${primaryLocation}`);
      
      if (selectedOptions && selectedOptions.length > 0) {
        let addedCount = 0;
        
        for (const section of selectedOptions) {
          console.log(`📍 Adding students from section: ${section.value}`);
          const response = await get_students_by_section(section.value);
          
          let studentsList = [];
          
          if (Array.isArray(response?.students)) {
            studentsList = response.students;
          } else if (Array.isArray(response?.data?.students)) {
            studentsList = response.data.students;
          } else if (Array.isArray(response?.data)) {
            studentsList = response.data;
          } else if (Array.isArray(response)) {
            studentsList = response;
          }
          
          console.log(`✅ Got ${studentsList.length} students from ${section.value}`);
          
          const existingIds = new Set(allStudents.map(s => s.student_id));
          const newStudents = studentsList.filter(s => !existingIds.has(s.student_id));
          
          console.log(`➕ Adding ${newStudents.length} new students from ${section.value}`);
          allStudents = [...allStudents, ...newStudents];
          addedCount += newStudents.length;
        }
        
        console.log(`📊 Total students after adding sections: ${allStudents.length}`);
        toast.success(`✅ Added ${addedCount} students from ${selectedOptions.length} section(s)`);
      } else {
        console.log(`📍 No additional sections selected, keeping primary location students only`);
        toast.info(`🔄 Showing ${allStudents.length} students from primary location`);
      }
      
      setStudents(allStudents);
      setStudentsId(allStudents.map((s) => s.student_id));
      
    } catch (err) {
      console.error("Error handling additional sections:", err);
      toast.error("Failed to load students from selected sections");
    } finally {
      setLoadingStudents(false);
    }
  };

  // ============================================================
  // CALENDAR LOGIC
  // ============================================================
  const loadCalendar = async () => {
    setLoadingCalendar(true);
    try {
      const startDate = new Date(values.start_date);
      const endDate = new Date(values.end_date);

      if (!startDate || !endDate || startDate > endDate) {
        toast.error("Invalid date range");
        setLoadingCalendar(false);
        return;
      }

      const effectiveStartDate = new Date(startDate);
      const effectiveEndDate = new Date(endDate);
      
      const months = new Set();
      for (let d = new Date(effectiveStartDate); d <= effectiveEndDate; d.setDate(d.getDate() + 1)) {
        const year = d.getFullYear();
        const month = d.getMonth() + 1;
        months.add(`${year}-${month}`);
      }

      let holidaysMap = {};

      for (const monthKey of months) {
        const [year, month] = monthKey.split("-");
        try {
          const response = await getHolidaysByMonth(parseInt(year), parseInt(month));
          if (response?.data?.holidays) {
            response.data.holidays.forEach((holiday) => {
              holidaysMap[holiday.date] = holiday.name;
            });
          }
        } catch (err) {
          console.error(`Error fetching holidays for ${monthKey}:`, err);
        }
      }

      setHolidays(holidaysMap);

      const dates = [];
      for (let d = new Date(effectiveStartDate); d <= effectiveEndDate; d.setDate(d.getDate() + 1)) {
        const dateStr = d.toISOString().split("T")[0];
        const dayOfWeek = d.getDay();

        dates.push({
          date: dateStr,
          dayName: d.toLocaleDateString("en-US", { weekday: "short" }),
          dayNum: d.getDate(),
          month: d.toLocaleDateString("en-US", { month: "short" }),
          year: d.getFullYear(),
          isSunday: dayOfWeek === 0,
          isHoliday: !!holidaysMap[dateStr],
          holidayName: holidaysMap[dateStr] || "",
        });
      }

      setCalendarDates(dates);
      
      if (selectedDates.length === 0) {
        const allWeekdaysInRange = dates
          .filter(d => !d.isSunday && !d.isHoliday)
          .map(d => d.date);
        
        setSelectedDates(allWeekdaysInRange);
        console.log("📅 No prior dates found, set defaults to weekdays:", allWeekdaysInRange.length);
      } else {
        console.log("📅 Preserving existing dates from DB:", selectedDates.length);
      }

    } catch (err) {
      console.error("Error loading calendar:", err);
      toast.error("Failed to load calendar");
    } finally {
      setLoadingCalendar(false);
    }
  };

  // ============================================================
  // DATE SELECTION
  // ============================================================
  const toggleDate = (date) => {
    setSelectedDates((prev) => {
      if (prev.includes(date)) {
        return prev.filter((d) => d !== date);
      } else {
        return [...prev, date];
      }
    });
  };

  const resetToDefaultWeekdays = () => {
    const weekdaysOnly = calendarDates
      .filter((d) => !d.isSunday && !d.isHoliday)
      .map((d) => d.date);
    setSelectedDates(weekdaysOnly);
    toast.success(`✅ Reset: Selected ${weekdaysOnly.length} weekdays (Mon-Sat, excluding holidays)`);
  };

  const selectAllSundays = () => {
    const sundays = calendarDates
      .filter((d) => d.isSunday)
      .map((d) => d.date);
    setSelectedDates((prev) => [...new Set([...prev, ...sundays])]);
    toast.success(`✅ Added ${sundays.length} Sundays`);
  };

  const deselectAllSundays = () => {
    setSelectedDates((prev) =>
      prev.filter((d) => !calendarDates.find((cd) => cd.date === d && cd.isSunday))
    );
    toast.info("❌ Cleared all Sundays");
  };

  const selectAllHolidays = () => {
    const holidayDates = calendarDates
      .filter((d) => d.isHoliday)
      .map((d) => d.date);
    setSelectedDates((prev) => [...new Set([...prev, ...holidayDates])]);
    toast.success(`✅ Added ${holidayDates.length} holidays`);
  };

  const deselectAllHolidays = () => {
    setSelectedDates((prev) =>
      prev.filter((d) => !calendarDates.find((cd) => cd.date === d && cd.isHoliday))
    );
    toast.info("❌ Cleared all holidays");
  };

  const handleChange = (event, name) => {
    const value = event?.value ?? event?.target?.value;
    setValues((prev) => ({
      ...prev,
      [name]: isNaN(value) ? value : Number(value),
    }));
  };

  const handleStudentSelect = (event, studentId) => {
    const checked = event.target.checked;
    if (checked) {
      setStudentsId((prev) => [...prev, studentId]);
    } else {
      setStudentsId((prev) => prev.filter((id) => id !== studentId));
    }
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setStudentsId(students.map((s) => s.student_id));
    } else {
      setStudentsId([]);
    }
  };

  const handleDeleteSession = async () => {
    if (!window.confirm("Are you sure you want to delete this session?")) {
      return;
    }

    try {
      setLoading(true);
      await deleteSessionService({
        session_id: String(values.session_id),
      });
      toast.success("✅ Session deleted successfully");
      resetSessionView();

      setTimeout(() => {
        fetchSessions();
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete session");
    } finally {
      setLoading(false);
    }
  };

  const handleStartEdit = async () => {
    setSessionMode("edit");
    await loadCalendar();
  };

  const handleSaveChanges = async () => {
    if (sessionMode !== "edit") return;

    if (selectedDates.length === 0) {
      toast.error("❌ Please select at least one date to run the class");
      return;
    }

    try {
      setLoading(true);

      const selectedStudents = students.filter((s) =>
        studentsId.includes(s.student_id)
      );

      const additionalSectionsList = selectedAdditionalSections.map(s => s.value);

      const payload = {
        session_id: String(values.session_id),
        course_name: values.course_name,
        location: values.location,
        start_date: values.start_date,
        end_date: values.end_date,
        start_time: values.start_time,
        end_time: values.end_time,
        student_ids: selectedStudents.map((s) => String(s.student_id)),
        class_dates: selectedDates,
        additional_sections: additionalSectionsList,
      };

      console.log("📤 Payload being sent to backend:");
      console.log("   session_id:", payload.session_id);
      console.log("   class_dates:", payload.class_dates.length);
      console.log("   additional_sections:", payload.additional_sections);

      const response = await editSessionService(payload);
      
      console.log("📥 Response from backend:", response.data);

      toast.success("✅ Session updated successfully");
      setSessionMode("view");
      setCalendarDates([]);

      setTimeout(() => {
        fetchSessions();
      }, 500);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update session");
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // CALENDAR VIEW COMPONENT (FIXED)
  // ============================================================
  const CalendarView = () => {
    if (calendarDates.length === 0) return null;

    const monthGroups = {};
    calendarDates.forEach((dateObj) => {
      const monthKey = `${dateObj.month} ${dateObj.year}`;
      if (!monthGroups[monthKey]) {
        monthGroups[monthKey] = [];
      }
      monthGroups[monthKey].push(dateObj);
    });

    return (
      <div style={{ padding: "16px", backgroundColor: "#f9f9f9", borderRadius: "8px", marginTop: "1rem" }}>
        
        {/* ✅ HOSTEL NOTICE */}
        {selectedHostel && (
          <div style={{
            padding: "12px",
            backgroundColor: "#e3f2fd",
            borderLeft: "4px solid #2196f3",
            marginBottom: "1rem",
            borderRadius: "4px"
          }}>
            <strong>🏨 {selectedHostel.label} - Hostel Attendance</strong>
            <p style={{ margin: "8px 0 0 0", fontSize: "13px", color: "#555" }}>
              📅 Schedule: <strong>EVERY DAY</strong>
              <br/>
              <span style={{ color: "#1976d2", fontSize: "12px" }}>
                ✅ Monday - Sunday (including weekends and holidays)
              </span>
            </p>
            <p style={{ margin: "8px 0 0 0", fontSize: "12px", color: "#666" }}>
              💡 Tip: You can uncheck specific dates if hostel is closed that day
            </p>
          </div>
        )}

        {!selectedHostel && (
          <div style={{
            padding: "12px",
            backgroundColor: "#fff3cd",
            borderLeft: "4px solid #ffc107",
            marginBottom: "1rem",
            borderRadius: "4px"
          }}>
            <strong>📚 Regular Class Schedule</strong>
            <p style={{ margin: "8px 0 0 0", fontSize: "13px", color: "#555" }}>
              📅 Default: <strong>Monday - Saturday</strong>
              <br/>
              <span style={{ color: "#856404", fontSize: "12px" }}>
                ❌ No Sundays, ❌ No holidays
              </span>
            </p>
            <p style={{ margin: "8px 0 0 0", fontSize: "12px", color: "#666" }}>
              💡 Tip: Click Sundays or holidays to add them if needed
            </p>
          </div>
        )}

        <h3 style={{ marginTop: 0 }}>📅 Select Exceptions (Optional)</h3>
        <p style={{ color: "#666", fontSize: "14px", marginBottom: "1rem", fontStyle: "italic" }}>
          {selectedHostel 
            ? "✅ All dates are selected for hostel attendance. Uncheck dates if hostel is closed."
            : "✅ Default: Class runs on weekdays (Mon-Sat, excluding holidays). Customize as needed."
          }
        </p>

        <div style={{ marginBottom: "16px", display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {!selectedHostel && (
            <>
              <button
                onClick={resetToDefaultWeekdays}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#2e7d32",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ↺ Reset to Weekdays
              </button>

              <button
                onClick={selectAllSundays}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#ff9800",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ➕ Add Sundays
              </button>

              <button
                onClick={deselectAllSundays}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ➖ Remove Sundays
              </button>

              <button
                onClick={selectAllHolidays}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#f44336",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ➕ Add Holidays
              </button>

              <button
                onClick={deselectAllHolidays}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ➖ Remove Holidays
              </button>
            </>
          )}
          
          {selectedHostel && (
            <>
              <button
                onClick={() => {
                  setSelectedDates(calendarDates.map(d => d.date));
                  toast.success(`✅ Selected all ${calendarDates.length} days for hostel`);
                }}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#2e7d32",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ✅ Select All Days
              </button>

              <button
                onClick={() => {
                  setSelectedDates([]);
                  toast.info(`ℹ️ Deselected all days`);
                }}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#d32f2f",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
              >
                ❌ Deselect All Days
              </button>
            </>
          )}
        </div>

        {Object.entries(monthGroups).map(([month, monthDates]) => (
          <div key={month} style={{ marginBottom: "24px" }}>
            <h4 style={{ color: "#0066cc", marginBottom: "12px", fontSize: "16px" }}>
              📆 {month}
            </h4>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                gap: "8px",
              }}
            >
              {monthDates.map((dateObj) => {
                const isSelected = selectedDates.includes(dateObj.date);
                let bgColor = "#ffffff";
                let borderColor = "#ddd";
                let textColor = "black";
                let icon = "";

                if (dateObj.isHoliday) {
                  bgColor = isSelected ? "#ffe082" : "#fff9c4";
                  borderColor = "#fbc02d";
                  textColor = "#f57f17";
                  icon = isSelected ? "✅" : "🏖️";
                } else if (dateObj.isSunday) {
                  bgColor = isSelected ? "#e0e0e0" : "#ffffff";
                  borderColor = isSelected ? "#616161" : "#bdbdbd";
                  textColor = isSelected ? "#212121" : "#616161";
                  icon = isSelected ? "✅" : "☀️";
                } else {
                  bgColor = isSelected ? "#c8e6c9" : "#f0f0f0";
                  borderColor = isSelected ? "#4caf50" : "#ddd";
                  textColor = isSelected ? "#2e7d32" : "black";
                  icon = isSelected ? "✅" : "";
                }

                return (
                  <div
                    key={dateObj.date}
                    onClick={() => toggleDate(dateObj.date)}
                    style={{
                      padding: "12px 8px",
                      backgroundColor: bgColor,
                      border: `2px solid ${borderColor}`,
                      borderRadius: "6px",
                      cursor: "pointer",
                      textAlign: "center",
                      transition: "all 0.2s",
                      userSelect: "none",
                      minHeight: "90px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      color: textColor,
                      fontWeight: "600",
                    }}
                  >
                    <div style={{ fontSize: "16px", fontWeight: "700", marginBottom: "4px" }}>
                      {dateObj.dayNum}
                    </div>
                    <div style={{ fontSize: "10px", fontWeight: "600", marginBottom: "4px" }}>
                      {dateObj.dayName}
                    </div>
                    {icon && (
                      <div style={{ fontSize: "20px", marginTop: "4px" }}>
                        {icon}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {(() => {
          const regularDays = selectedDates.filter(d => {
            const dateObj = calendarDates.find(cd => cd.date === d);
            return dateObj && !dateObj.isSunday && !dateObj.isHoliday;
          }).length;
          
          const sundaysIncluded = selectedDates.filter(d => {
            const dateObj = calendarDates.find(cd => cd.date === d);
            return dateObj && dateObj.isSunday;
          }).length;
          
          const holidaysIncluded = selectedDates.filter(d => {
            const dateObj = calendarDates.find(cd => cd.date === d);
            return dateObj && dateObj.isHoliday;
          }).length;
          
          return (
            <div
              style={{
                marginTop: "20px",
                padding: "15px",
                backgroundColor: "#e3f2fd",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              <strong>📍 Class Schedule Summary</strong>
              <div style={{ fontSize: "12px", color: "#666", marginTop: "8px" }}>
                ✅ Regular days (Mon-Sat): {regularDays} days
              </div>
              {sundaysIncluded > 0 && (
                <div style={{ fontSize: "12px", color: "#f57f17", marginTop: "4px" }}>
                  ☀️ Sundays included: {sundaysIncluded} days
                </div>
              )}
              {holidaysIncluded > 0 && (
                <div style={{ fontSize: "12px", color: "#d32f2f", marginTop: "4px" }}>
                  🏖️ Holidays included: {holidaysIncluded} days
                </div>
              )}
              <div style={{ 
                fontSize: "12px", 
                color: selectedHostel ? "#1976d2" : "#1976d2", 
                marginTop: "8px", 
                fontWeight: "bold" 
              }}>
                {selectedHostel ? "🏨" : "📚"} Total: {selectedDates.length} class days
              </div>
            </div>
          );
        })()}
      </div>
    );
  };

  return (
    <>
      {loading || loadingCalendar ? (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.35)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#222",
              padding: "16px 20px",
              borderRadius: 8,
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <Spinner size={22} color="#fff" />
            <div style={{ color: "#fff", fontWeight: 600 }}>
              {loadingCalendar ? "Loading calendar..." : "Saving..."}
            </div>
          </div>
        </div>
      ) : null}

      <main
        className="camcont m-4"
        style={{
          flexDirection: "column",
          gap: "1.5rem",
          justifyContent: "start",
        }}
      >
        <section className="student-panel" style={{ height: "auto" }}>
          <div className="input-section" style={{ gridTemplateColumns: "auto" }}>
            <div className="label-input" style={{ width: "400px" }}>
              <label className="label-fields large-text">📋 Select Session</label>
              <Select
                options={sessionIds}
                onChange={handleSelectSession}
                placeholder="Choose a session..."
                isClearable
                isLoading={loadingStudents}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: "rgb(51 65 85 / 63%)",
                    primary: "rgb(51 65 85)",
                  },
                })}
              />
            </div>
          </div>
        </section>

        {sessionMode && (
          <>
            <section className="student-panel" style={{ height: "auto" }}>
              <div className="input-section">
                <div className="label-input">
                  <label className="label-fields large-text">Session ID</label>
                  <input
                    type="text"
                    value={values.session_id}
                    disabled
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">Course</label>
                  <input
                    type="text"
                    value={values.course_name}
                    disabled
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">Location</label>
                  <input
                    type="text"
                    value={values.location}
                    onChange={(e) => handleChange(e, 'location')}
                    disabled={sessionMode === 'view'}
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">Start Date</label>
                  <input
                    type="date"
                    value={values.start_date}
                    onChange={(e) => handleChange(e, 'start_date')}
                    disabled={sessionMode === 'view'}
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">End Date</label>
                  <input
                    type="date"
                    value={values.end_date}
                    onChange={(e) => handleChange(e, 'end_date')}
                    disabled={sessionMode === 'view'}
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">Start Time</label>
                  <input
                    type="time"
                    value={values.start_time}
                    onChange={(e) => handleChange(e, 'start_time')}
                    disabled={sessionMode === 'view'}
                    className="input-fields"
                  />
                </div>

                <div className="label-input">
                  <label className="label-fields large-text">End Time</label>
                  <input
                    type="time"
                    value={values.end_time}
                    onChange={(e) => handleChange(e, 'end_time')}
                    disabled={sessionMode === 'view'}
                    className="input-fields"
                  />
                </div>

                {sessionMode === "edit" && (
                  <div className="label-input">
                    <label className="label-fields large-text">➕ Additional Sections</label>
                    <div className="select-wrapper">
                      <Select
                        isMulti
                        options={sections.filter(
                          (s) => s.value !== values.location
                        )}
                        onChange={handleAdditionalSectionsChange}
                        value={selectedAdditionalSections}
                        placeholder="Select additional sections (optional)"
                        isDisabled={loadingStudents}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 4,
                          colors: {
                            ...theme.colors,
                            primary25: "rgb(51 65 85 / 63%)",
                            primary: "rgb(51 65 85)",
                          },
                        })}
                      />
                    </div>
                    <small style={{ color: "#666", marginTop: "0.25rem", display: "block" }}>
                      {selectedAdditionalSections.length > 0
                        ? `${selectedAdditionalSections.length} additional section(s) selected`
                        : "Select additional sections to add students from multiple locations"}
                    </small>
                  </div>
                )}

                {sessionMode === "edit" && filterByHostel && hostels.length > 0 && (
                  <div className="label-input">
                    <label className="label-fields large-text">🏨 Select Hostel (Optional)</label>
                    <div className="select-wrapper">
                      <Select
                        options={hostels}
                        onChange={handleHostelChange}
                        value={selectedHostel}
                        placeholder="Select hostel to filter students"
                        isClearable
                        isDisabled={loadingHostels}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 4,
                          colors: {
                            ...theme.colors,
                            primary25: "rgb(51 65 85 / 63%)",
                            primary: "rgb(51 65 85)",
                          },
                        })}
                      />
                    </div>
                    <small style={{ color: "#666", marginTop: "0.25rem", display: "block" }}>
                      {selectedHostel 
                        ? `Showing students from ${selectedHostel.label} (all sections)`
                        : "Leave blank to show all students from primary location"
                      }
                    </small>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "flex-end",
                  paddingTop: "1.5rem",
                  marginTop: "1.5rem",
                }}
              >
                {sessionMode === "view" ? (
                  <>
                    <button
                      onClick={handleStartEdit}
                      className="submit-button"
                      style={{ backgroundColor: "#ffc107" }}
                    >
                      ✏️ Edit Session
                    </button>
                    <button
                      onClick={handleDeleteSession}
                      className="submit-button"
                      style={{ backgroundColor: "#e74c3c" }}
                    >
                      🗑️ Delete
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => {
                        setSessionMode("view");
                        setCalendarDates([]);
                      }}
                      className="submit-button"
                      style={{ backgroundColor: "#999" }}
                    >
                      ❌ Cancel
                    </button>
                    <button
                      onClick={handleSaveChanges}
                      className="submit-button"
                      style={{ backgroundColor: "#00aa44" }}
                      disabled={loading}
                    >
                      {loading ? (
                        <Spinner size={16} color="#fff" />
                      ) : (
                        "💾 Save"
                      )}
                    </button>
                  </>
                )}
              </div>
            </section>

            {sessionMode === "edit" && <CalendarView />}

            <section className="student-panel" style={{ height: "auto" }}>
              <div
                style={{
                  padding: "10px",
                  background: "#f5f5f5",
                  marginBottom: "10px",
                  borderRadius: "4px",
                }}
              >
                <strong>
                  Total: {students.length} | Selected: {studentsId.length}
                </strong>
              </div>

              <div
                className={styles.tableContainer}
                style={{ maxHeight: "90vh", overflowY: "auto" }}
              >
                {students.length > 0 ? (
                  <table>
                    <thead style={{ position: "sticky", top: 0 }}>
                      <tr>
                        <th>
                          {sessionMode === "edit" && (
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                studentsId.length === students.length &&
                                students.length > 0
                              }
                            />
                          )}
                        </th>
                        <th>Image</th>
                        <th>Student ID</th>
                        <th>First Name</th>
                        <th>Last Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {students.map((student, index) => (
                        <tr key={`${student.student_id}-${index}`}>
                          <td>
                            {sessionMode === "edit" && (
                              <input
                                type="checkbox"
                                checked={studentsId.includes(student.student_id)}
                                onChange={(e) =>
                                  handleStudentSelect(e, student.student_id)
                                }
                              />
                            )}
                          </td>
                          <td className="es-th">
                            <img
                              src={`${base64},${student.image}`}
                              width="100px"
                              height="100px"
                              alt={student.student_id}
                              style={{ objectFit: "cover", borderRadius: 6 }}
                            />
                          </td>
                          <td style={{ fontSize: "1.25rem" }} className="es-th">
                            {student.student_id}
                          </td>
                          <td style={{ fontSize: "1.25rem" }} className="es-th">
                            {student.first_name}
                          </td>
                          <td style={{ fontSize: "1.25rem" }} className="es-th">
                            {student.last_name}
                          </td>
                          <td style={{ fontSize: "1.25rem" }} className="es-th">
                            {student.email}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div
                    style={{
                      padding: "40px 20px",
                      textAlign: "center",
                      color: "#999",
                    }}
                  >
                    No students enrolled
                  </div>
                )}
              </div>
            </section>
          </>
        )}

        {!sessionMode && (
          <div
            style={{
              padding: "60px 20px",
              textAlign: "center",
              color: "#999",
              minHeight: "400px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              <div style={{ fontSize: "48px", marginBottom: "20px" }}>📋</div>
              <div style={{ fontSize: "18px", fontWeight: "600" }}>
                Select a session to begin
              </div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}